export default __webpack_public_path__ + "static/media/ASC_Logo_Cloud-Solutions_700pxBreit.eb016ca7.jpg";